import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useLocalizationContext } from '@sharesight/gatsby-plugin-sharesight-localization';

import { useCookiePreferences } from 'components/CookiePreferences/CookiePreferencesProvider';

export const Datadog = () => {
  const cookiePreferences = useCookiePreferences();
  const { currentLocale } = useLocalizationContext();

  useEffect(() => {
    // GDPR: Only initialise datadog if performance cookies are accepted or the user is on an au/nz locale
    if (cookiePreferences?.performance) {
      datadogRum.init({
        applicationId: '05b2c304-e24f-416d-9c84-5c0d3403e395',
        clientToken: 'pubd1ee8f5b1edcf666bc666980a2903110',
        site: 'datadoghq.com',
        service: 'static-www',
        env: process.env.NODE_ENV || 'production',
        version: process.env.GATSBY_DD_VERSION || undefined,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackSessionAcrossSubdomains: true,
        allowedTracingUrls: [/https:\/\/.*\.sharesight\.com/],
        defaultPrivacyLevel: 'mask-user-input',
      });
    }
  }, [cookiePreferences?.performance, currentLocale.id]);

  return null;
};
